import React from 'react';

import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ContentWrapper from 'components/core/content-wrapper';
import ProductImage from 'components/product-image';
import ProductImages from 'components/product-images';
import { Typography } from 'src/typography';

const PRODUCT_IMAGE_WIDTH_DESKTOP = 450;
const PRODUCT_IMAGE_WIDTH_MOBILE = 410;

export function Container({ children, ...otherProps }) {
  return (
    <ContentWrapper bg='var(--dcm-product-page-bg)' margin='4px 20px 0;' {...otherProps}>
      <RootContainer>{children}</RootContainer>
    </ContentWrapper>
  );
}

export function Images({ product, isUnavailable }) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down(`sm`));
  const resolvedImageWidth = isMobile ? PRODUCT_IMAGE_WIDTH_MOBILE : PRODUCT_IMAGE_WIDTH_DESKTOP;

  const activeImages = product.images?.filter((img) => img.active);

  return (
    <ImagesContainer $isUnavailable={isUnavailable}>
      {activeImages?.length > 0 ? (
        <ProductImages images={product.images} isZoomable width={resolvedImageWidth} />
      ) : (
        <ProductImage product={product} width={resolvedImageWidth} isZoomable />
      )}
    </ImagesContainer>
  );
}

const RootContainer = styled.div`
  margin: 0 auto;
  max-width: 1052px;
  min-height: var(--dtch-cls-min-height, calc(100vh - 300px));
  padding: 16px 0 140px 0;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    align-items: center;
    flex-direction: column;
  }
`;

export const Details = styled.div`
  flex: 1 0 0%;
  min-width: 0;
  margin: 0;
  margin-top: 15px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin: 0 28px;
  }
`;

const ImagesContainer = styled.div`
  flex: 0 0 ${PRODUCT_IMAGE_WIDTH_DESKTOP}px;
  margin-right: 62px;
  min-width: 0;
  padding-top: 20px;
  padding-bottom: 0;
  border-radius: 3px;
  position: sticky;
  top: 0;
  opacity: ${({ $isUnavailable }) => ($isUnavailable ? `50%` : `100%`)};

  img {
    border-radius: 3px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex: 0 0 0;
    margin-right: 0;
    padding-bottom: 24px;
    position: relative;
    top: unset;
  }
`;

export const AddToCartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const AddToCartErrorContainer = styled.div`
  margin-bottom: ${({ includeBottomMargin }) => (includeBottomMargin ? `20px` : '0')};
`;

export const AddToCartError = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.red[45]}; ;
`;

export const ButtonContainer = styled.div`
  margin-bottom: 39px;
`;

export const CarouselContainer = styled.div`
  margin-bottom: 24px;
`;

export const TaxText = styled.p`
  color: var(--dcm-product-detail-muted-color, ${({ theme }) => theme.colors.grey[60]});
  font-family: var(--dcm-font-secondary);
  font-size: 12px;
  margin-bottom: 24px;
`;

export const UnavailableText = styled.p`
  color: var(--dcm-product-detail-muted-color, ${({ theme }) => theme.colors.grey[40]});
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 35px;
`;
